import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { LanguageDropDownComponent } from './language-drop-down.component';

import { FormsModule, ReactiveFormsModule } from '@angular/forms';
import { MatButtonModule } from '@angular/material/button';
import { MatIconModule } from '@angular/material/icon';
import {MatMenuModule} from '@angular/material/menu';
import {MatInputModule} from '@angular/material/input';
import {matSelectAnimations, MatSelectModule} from '@angular/material/select';




@NgModule({
  declarations: [
    LanguageDropDownComponent
  ],
  imports: [
    CommonModule,
    FormsModule, 
    ReactiveFormsModule,MatButtonModule,MatIconModule,MatMenuModule,MatInputModule,MatSelectModule,
  ],
  exports : [
    LanguageDropDownComponent
  ]
  
})
export class LanguageDropDownModule { }
